module.exports = __webpack_public_path__ + "images/icon-128.11292c44ee45055e080b5acbd367dd4d.png";